/* eslint-disable */
export const createCargoMovement = /* GraphQL */ `
  mutation CreateCargoMovement(
    $input: CreateCargoMovementInput!
    $condition: ModelCargoMovementConditionInput
  ) {
    createCargoMovement(input: $input, condition: $condition) {
      id
      secuencia
      bl_guia
      origin
      puerto_carga
      destino
      puerto_descarga
      agente_transporte
      tipo_transporte
      commotity
      measures
      weigth
      vweigth
      etd
      eta
      tipo_despacho
      almacen_fiscal
      recibo
      semaforo
      dua
      fecha_dua
      transporte_interno
      tramitador
      status
      createdAt
      type
      updatedAt
      __typename
    }
  }
`;
export const updateCargoMovement = /* GraphQL */ `
  mutation UpdateCargoMovement(
    $input: UpdateCargoMovementInput!
    $condition: ModelCargoMovementConditionInput
  ) {
    updateCargoMovement(input: $input, condition: $condition) {
      id
      secuencia
      bl_guia
      origin
      puerto_carga
      destino
      puerto_descarga
      agente_transporte
      tipo_transporte
      commotity
      measures
      weigth
      vweigth
      etd
      eta
      tipo_despacho
      almacen_fiscal
      recibo
      semaforo
      dua
      fecha_dua
      transporte_interno
      tramitador
      status
      createdAt
      type
      updatedAt
      __typename
    }
  }
`;
export const deleteCargoMovement = /* GraphQL */ `
  mutation DeleteCargoMovement(
    $input: DeleteCargoMovementInput!
    $condition: ModelCargoMovementConditionInput
  ) {
    deleteCargoMovement(input: $input, condition: $condition) {
      id
      secuencia
      bl_guia
      origin
      puerto_carga
      destino
      puerto_descarga
      agente_transporte
      tipo_transporte
      commotity
      measures
      weigth
      vweigth
      etd
      eta
      tipo_despacho
      almacen_fiscal
      recibo
      semaforo
      dua
      fecha_dua
      transporte_interno
      tramitador
      status
      createdAt
      type
      updatedAt
      __typename
    }
  }
`;
export const createDeliveryRoute = /* GraphQL */ `
  mutation CreateDeliveryRoute(
    $input: CreateDeliveryRouteInput!
    $condition: ModelDeliveryRouteConditionInput
  ) {
    createDeliveryRoute(input: $input, condition: $condition) {
      id
      secuencia
      delivery_man
      date
      status
      comments
      createdAt
      updatedAt
      type
      __typename
    }
  }
`;
export const updateDeliveryRoute = /* GraphQL */ `
  mutation UpdateDeliveryRoute(
    $input: UpdateDeliveryRouteInput!
    $condition: ModelDeliveryRouteConditionInput
  ) {
    updateDeliveryRoute(input: $input, condition: $condition) {
      id
      secuencia
      delivery_man
      date
      status
      comments
      createdAt
      updatedAt
      type
      __typename
    }
  }
`;
export const deleteDeliveryRoute = /* GraphQL */ `
  mutation DeleteDeliveryRoute(
    $input: DeleteDeliveryRouteInput!
    $condition: ModelDeliveryRouteConditionInput
  ) {
    deleteDeliveryRoute(input: $input, condition: $condition) {
      id
      secuencia
      delivery_man
      date
      status
      comments
      createdAt
      updatedAt
      type
      __typename
    }
  }
`;

export const createBox = /* GraphQL */ `
  mutation CreateBox(
    $input: CreateBoxInput!
    $condition: ModelBoxConditionInput
  ) {
    createBox(input: $input, condition: $condition) {
      id
      secuencia
      warehouseNumber
      client
      provedor
      origin
      puerto_carga
      destino
      puerto_descarga
      manifiest_number
      measures
      weigth
      vweigth
      warehouse_prealert_id
      tipo_transporte
      delivery_type
      commotity
      createdAt
      isDelivered
      onRoute
      tracking_num
      tax_calculated
      received
      exempt_process_request
      courier
      cost
      type
      data
      updatedAt
      cargoMovementBoxesId
      deliveryRouteBoxesId
      poBoxBoxesId
      boxBoxCostId
      __typename
    }
  }
`;
export const updateBox = /* GraphQL */ `
  mutation UpdateBox(
    $input: UpdateBoxInput!
    $condition: ModelBoxConditionInput
  ) {
    updateBox(input: $input, condition: $condition) {
      id
      secuencia
      warehouseNumber
      client
      provedor
      origin
      puerto_carga
      destino
      puerto_descarga
      manifiest_number
      measures
      weigth
      vweigth
      warehouse_prealert_id
      tipo_transporte
      delivery_type
      commotity
      createdAt
      isDelivered
      onRoute
      tracking_num
      tax_calculated
      received
      exempt_process_request
      courier
      cost
      type
      data
      updatedAt
      cargoMovementBoxesId
      deliveryRouteBoxesId
      poBoxBoxesId
      boxBoxCostId
      __typename
    }
  }
`;
export const deleteBox = /* GraphQL */ `
  mutation DeleteBox(
    $input: DeleteBoxInput!
    $condition: ModelBoxConditionInput
  ) {
    deleteBox(input: $input, condition: $condition) {
      id
      secuencia
      warehouseNumber
      client
      provedor
      origin
      puerto_carga
      destino
      puerto_descarga
      manifiest_number
      measures
      weigth
      vweigth
      warehouse_prealert_id
      tipo_transporte
      delivery_type
      commotity
      createdAt
      isDelivered
      onRoute
      tracking_num
      tax_calculated
      received
      exempt_process_request
      courier
      cost
      type
      data
      updatedAt
      cargoMovementBoxesId
      deliveryRouteBoxesId
      poBoxBoxesId
      boxBoxCostId
      __typename
    }
  }
`;

export const createAddress = /* GraphQL */ `
  mutation CreateAddress(
    $input: CreateAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    createAddress(input: $input, condition: $condition) {
      id
      name
      delivery_province
      delivery_canton
      delivery_district
      address
      createdAt
      type
      updatedAt
      poBoxAddressesId
      __typename
    }
  }
`;
export const updateAddress = /* GraphQL */ `
  mutation UpdateAddress(
    $input: UpdateAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    updateAddress(input: $input, condition: $condition) {
      id
      name
      delivery_province
      delivery_canton
      delivery_district
      address
      createdAt
      type
      updatedAt
      poBoxAddressesId
      __typename
    }
  }
`;
export const deleteAddress = /* GraphQL */ `
  mutation DeleteAddress(
    $input: DeleteAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    deleteAddress(input: $input, condition: $condition) {
      id
      name
      delivery_province
      delivery_canton
      delivery_district
      address
      createdAt
      type
      updatedAt
      poBoxAddressesId
      __typename
    }
  }
`;
export const createBoxCost = /* GraphQL */ `
  mutation CreateBoxCost(
    $input: CreateBoxCostInput!
    $condition: ModelBoxCostConditionInput
  ) {
    createBoxCost(input: $input, condition: $condition) {
      id
      invoiceId
      settlementId
      subtotal
      iva
      discount
      comision
      total
      priceType
      exchangeRate
      createdAt
      type
      data
      easyposLog
      updatedAt
      boxCostBoxId
      __typename
    }
  }
`;

export const updateBoxCost = /* GraphQL */ `
  mutation UpdateBoxCost(
    $input: UpdateBoxCostInput!
    $condition: ModelBoxCostConditionInput
  ) {
    updateBoxCost(input: $input, condition: $condition) {
      id
      invoiceId
      settlementId
      subtotal
      iva
      discount
      comision
      total
      priceType
      exchangeRate
      createdAt
      type
      data
      easyposLog
      updatedAt
      boxCostBoxId
      __typename
    }
  }
`;
export const deleteBoxCost = /* GraphQL */ `
  mutation DeleteBoxCost(
    $input: DeleteBoxCostInput!
    $condition: ModelBoxCostConditionInput
  ) {
    deleteBoxCost(input: $input, condition: $condition) {
      id
      invoiceId
      settlementId
      subtotal
      iva
      discount
      comision
      total
      priceType
      exchangeRate
      createdAt
      type
      data
      easyposLog
      updatedAt
      boxCostBoxId
      __typename
    }
  }
`;
export const createAsset = /* GraphQL */ `
  mutation CreateAsset(
    $input: CreateAssetInput!
    $condition: ModelAssetConditionInput
  ) {
    createAsset(input: $input, condition: $condition) {
      id
      name
      path
      type
      size
      createdAt
      updatedAt
      boxBoxAssetsId
      __typename
    }
  }
`;
export const updateAsset = /* GraphQL */ `
  mutation UpdateAsset(
    $input: UpdateAssetInput!
    $condition: ModelAssetConditionInput
  ) {
    updateAsset(input: $input, condition: $condition) {
      id
      name
      path
      type
      size
      createdAt
      updatedAt
      boxBoxAssetsId
      __typename
    }
  }
`;
export const deleteAsset = /* GraphQL */ `
  mutation DeleteAsset(
    $input: DeleteAssetInput!
    $condition: ModelAssetConditionInput
  ) {
    deleteAsset(input: $input, condition: $condition) {
      id
      name
      path
      type
      size
      createdAt
      updatedAt
      boxBoxAssetsId
      __typename
    }
  }
`;
export const createPoBox = /* GraphQL */ `
  mutation CreatePoBox(
    $input: CreatePoBoxInput!
    $condition: ModelPoBoxConditionInput
  ) {
    createPoBox(input: $input, condition: $condition) {
      id
      boxNumber
      name
      email
      phone
      type
      createdAt
      userId
      updatedAt
      __typename
    }
  }
`;
export const updatePoBox = /* GraphQL */ `
  mutation UpdatePoBox(
    $input: UpdatePoBoxInput!
    $condition: ModelPoBoxConditionInput
  ) {
    updatePoBox(input: $input, condition: $condition) {
      id
      boxNumber
      name
      email
      phone
      type
      createdAt
      userId
      updatedAt
      __typename
    }
  }
`;
export const deletePoBox = /* GraphQL */ `
  mutation DeletePoBox(
    $input: DeletePoBoxInput!
    $condition: ModelPoBoxConditionInput
  ) {
    deletePoBox(input: $input, condition: $condition) {
      id
      boxNumber
      name
      email
      phone
      type
      createdAt
      userId
      updatedAt
      __typename
    }
  }
`;
export const createPoBoxReferal = /* GraphQL */ `
  mutation CreatePoBoxReferal(
    $input: CreatePoBoxReferalInput!
    $condition: ModelPoBoxReferalConditionInput
  ) {
    createPoBoxReferal(input: $input, condition: $condition) {
      id
      referalCompleted
      type
      createdAt
      updatedAt
      poBoxReferalReferFromPoBoxId
      poBoxReferalReferToPoBoxId
      __typename
    }
  }
`;
export const updatePoBoxReferal = /* GraphQL */ `
  mutation UpdatePoBoxReferal(
    $input: UpdatePoBoxReferalInput!
    $condition: ModelPoBoxReferalConditionInput
  ) {
    updatePoBoxReferal(input: $input, condition: $condition) {
      id
      referalCompleted
      type
      createdAt
      updatedAt
      poBoxReferalReferFromPoBoxId
      poBoxReferalReferToPoBoxId
      __typename
    }
  }
`;
export const deletePoBoxReferal = /* GraphQL */ `
  mutation DeletePoBoxReferal(
    $input: DeletePoBoxReferalInput!
    $condition: ModelPoBoxReferalConditionInput
  ) {
    deletePoBoxReferal(input: $input, condition: $condition) {
      id
      referalCompleted
      type
      createdAt
      updatedAt
      poBoxReferalReferFromPoBoxId
      poBoxReferalReferToPoBoxId
      __typename
    }
  }
`;
export const createPoBoxReferalPoint = /* GraphQL */ `
  mutation CreatePoBoxReferalPoint(
    $input: CreatePoBoxReferalPointInput!
    $condition: ModelPoBoxReferalPointConditionInput
  ) {
    createPoBoxReferalPoint(input: $input, condition: $condition) {
      id
      amount
      description
      type
      createdAt
      updatedAt
      poBoxReferalPointReferalPoBoxId
      __typename
    }
  }
`;
export const updatePoBoxReferalPoint = /* GraphQL */ `
  mutation UpdatePoBoxReferalPoint(
    $input: UpdatePoBoxReferalPointInput!
    $condition: ModelPoBoxReferalPointConditionInput
  ) {
    updatePoBoxReferalPoint(input: $input, condition: $condition) {
      id
      amount
      description
      type
      createdAt
      updatedAt
      poBoxReferalPointReferalPoBoxId
      __typename
    }
  }
`;
export const deletePoBoxReferalPoint = /* GraphQL */ `
  mutation DeletePoBoxReferalPoint(
    $input: DeletePoBoxReferalPointInput!
    $condition: ModelPoBoxReferalPointConditionInput
  ) {
    deletePoBoxReferalPoint(input: $input, condition: $condition) {
      id
      amount
      description
      type
      createdAt
      updatedAt
      poBoxReferalPointReferalPoBoxId
      __typename
    }
  }
`;
export const createPrice = /* GraphQL */ `
  mutation CreatePrice(
    $input: CreatePriceInput!
    $condition: ModelPriceConditionInput
  ) {
    createPrice(input: $input, condition: $condition) {
      id
      type
      secuencia
      name
      isAllInclusive
      isPublic
      isDefault
      isActive
      priceTable
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePrice = /* GraphQL */ `
  mutation UpdatePrice(
    $input: UpdatePriceInput!
    $condition: ModelPriceConditionInput
  ) {
    updatePrice(input: $input, condition: $condition) {
      id
      type
      secuencia
      name
      isAllInclusive
      isPublic
      isDefault
      isActive
      priceTable
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePrice = /* GraphQL */ `
  mutation DeletePrice(
    $input: DeletePriceInput!
    $condition: ModelPriceConditionInput
  ) {
    deletePrice(input: $input, condition: $condition) {
      id
      type
      secuencia
      name
      isAllInclusive
      isPublic
      isDefault
      isActive
      priceTable
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTypeCounter = /* GraphQL */ `
  mutation CreateTypeCounter(
    $input: CreateTypeCounterInput!
    $condition: ModelTypeCounterConditionInput
  ) {
    createTypeCounter(input: $input, condition: $condition) {
      id
      type
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTypeCounter = /* GraphQL */ `
  mutation UpdateTypeCounter(
    $input: UpdateTypeCounterInput!
    $condition: ModelTypeCounterConditionInput
  ) {
    updateTypeCounter(input: $input, condition: $condition) {
      id
      type
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTypeCounter = /* GraphQL */ `
  mutation DeleteTypeCounter(
    $input: DeleteTypeCounterInput!
    $condition: ModelTypeCounterConditionInput
  ) {
    deleteTypeCounter(input: $input, condition: $condition) {
      id
      type
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
